module.exports = __webpack_public_path__ + "static/Wantsome-infra-code.4c7cce6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/community-events/Wantsome-infra-code.png
// module id = 560
// module chunks = 23550157048247